import { render } from "./forget-password.vue?vue&type=template&id=7b168de0&scoped=true"
import script from "./forget-password.vue?vue&type=script&lang=js"
export * from "./forget-password.vue?vue&type=script&lang=js"

import "./forget-password.vue?vue&type=style&index=0&id=7b168de0&scoped=true&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b168de0"]])

export default __exports__